import { BUKU_PROMOSI } from '../types'

export const bukuPromosiAction = (bukupromosi_action) => ({
    type: BUKU_PROMOSI,
    payload: bukupromosi_action
})